import { FC } from 'react';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
  alpha,
  useTheme,
  Badge,
} from '@mui/material';
import { Link } from '@vs-online-only-app/ui';
import {
  isPartOfCurrentPath,
  isRootLinkActive,
  useSidebarContext,
} from './SidebarContext';
import { SidebarMenuItem } from './types';

const MenuItem: FC<SidebarMenuItem> = ({
  Icon,
  label,
  id,
  path,
  badgeText,
}) => {
  const { isOpen } = useSidebarContext();
  const theme = useTheme();

  const isActivePartOfCurrentUrl = isPartOfCurrentPath(path);
  const isActive = isRootLinkActive(path) || isActivePartOfCurrentUrl;

  return (
    <Tooltip
      title={isOpen ? '' : <Typography>{label}</Typography>}
      key={id}
      placement="right"
      arrow
      enterDelay={1000}
    >
      <div>
        <ListItemButton
          LinkComponent={({ href, ref, ...props }) => (
            <Link to={href} underline="none" {...props} />
          )}
          href={path}
          selected={isActive}
          sx={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            gap: 2,
            height: '44px',
            backgroundColor: isActive
              ? alpha(theme.palette.primary.main, 0.1)
              : 'transparent',
          }}
          data-testid={`mpui-fw-sidebar-menu-item--${id}`}
        >
          <Badge color="success" badgeContent={badgeText || null}>
            <ListItemIcon
              sx={{
                minWidth: 0,
                paddingLeft: 1,
                ...(isActive ? { color: theme.palette.primary.main } : {}),
              }}
            >
              <Icon active={isActive} />
            </ListItemIcon>
          </Badge>
          <ListItemText
            sx={{
              margin: 0,
              opacity: isOpen ? 1 : 0,
              transition: 'opacity 300ms',
              whiteSpace: 'nowrap',
            }}
          >
            {label}
          </ListItemText>
        </ListItemButton>
      </div>
    </Tooltip>
  );
};

export default MenuItem;
